import { H3 } from "../../../../AbstractElements";
import { ServerSideProcessingHeading, ServerSideProcessingSpan1, ServerSideProcessingSpan2 } from "../../../../Constant";

const ServerSideProcessingHeader = () => {
  return (
    <div className="card-header pb-0 card-no-border">
      <H3 className="mb-3">{ServerSideProcessingHeading}</H3>
      <span dangerouslySetInnerHTML={{ __html: ServerSideProcessingSpan1 }} />
      <span dangerouslySetInnerHTML={{ __html: ServerSideProcessingSpan2 }} />
    </div>
  );
};
export default ServerSideProcessingHeader;
